import type { EntityType, RelationType } from '../types/index'

export const entityTypes: { value: EntityType; label: string; icon: string; color: string }[] = [
  { value: 'ORG', label: '组织机构(通用)', icon: '🏢', color: '#1565c0' },
  { value: 'ORG_BUYER', label: '招标人/采购人', icon: '🏛️', color: '#c2185b' },
  { value: 'ORG_AGENT', label: '招标代理机构', icon: '🏪', color: '#7b1fa2' },
  { value: 'ORG_BIDDER', label: '投标人/质疑方', icon: '🏭', color: '#388e3c' },
  { value: 'PROJECT', label: '项目名称', icon: '📋', color: '#ef6c00' },
  { value: 'DOC_ID', label: '文档编号', icon: '📄', color: '#5d4037' },
  { value: 'CLAUSE_TENDER', label: '招标文件条款', icon: '📑', color: '#455a64' },
  { value: 'REQUEST_ACTION', label: '请求措施', icon: '🎯', color: '#ad1457' },
  { value: 'DECISION_ACTION', label: '处理决定', icon: '✅', color: '#2e7d32' },
  { value: 'LAW', label: '法律法规', icon: '⚖️', color: '#303f9f' },
  { value: 'LAW_ARTICLE', label: '法律条款', icon: '📜', color: '#00796b' },
  { value: 'RISK_POINT', label: '风险点/质疑点', icon: '🎲', color: '#c62828' },
  { value: 'STRATEGY_KEYWORD', label: '策略关键词', icon: '🔧', color: '#2e7d32' },
  { value: 'MONEY', label: '金额', icon: '💰', color: '#f9a825' },
  { value: 'RATE', label: '比率/折扣率', icon: '📊', color: '#689f38' },
  { value: 'DATE', label: '日期/时间', icon: '📅', color: '#00838f' },
  { value: 'LOCATION', label: '地点/区域', icon: '📍', color: '#5d4037' },
]

export const relationTypes: { value: RelationType; label: string; description: string }[] = [
  { 
    value: 'involved_in', 
    label: '参与项目', 
    description: '组织机构参与项目'
  },
  { 
    value: 'raises_objection', 
    label: '提出质疑', 
    description: '投标人提出质疑'
  },
  { 
    value: 'cites_law', 
    label: '引用法规', 
    description: '文档或组织引用法律法规'
  },
  { 
    value: 'refers_to_location', 
    label: '项目所在地', 
    description: '项目位于某地'
  },
  { 
    value: 'cited_by', 
    label: '支撑决策', 
    description: '法规支撑决策'
  },
  { 
    value: 'refutes', 
    label: '反驳质疑', 
    description: '法规或条款反驳质疑'
  },
  { 
    value: 'supports', 
    label: '支持质疑', 
    description: '证据支持质疑'
  },
]

export const topicTypes = [
  { value: '资格条件', label: '资格条件', color: 'blue' },
  { value: '技术参数', label: '技术参数', color: 'purple' },
  { value: '报价评审', label: '报价评审', color: 'orange' },
  { value: '程序流程', label: '程序流程', color: 'cyan' },
  { value: '中标结果', label: '中标结果', color: 'green' },
  { value: '其他', label: '其他', color: 'default' },
]

export const positionTypes = [
  { value: '不采纳', label: '不采纳', color: 'red' },
  { value: '部分采纳', label: '部分采纳', color: 'orange' },
  { value: '完全采纳', label: '完全采纳', color: 'green' },
  { value: '澄清说明', label: '澄清说明', color: 'blue' },
]
